<template>
  <b-card-body style="padding: 0.5rem">
    <b-form @submit="downloadCsv">
      <b-form-group label="Data di inizio" id="export-form">
        <DatePicker v-model="startDate" id="start-date-export"/>
      </b-form-group>
      <b-form-group label="Data di fine">
        <DatePicker v-model="endDate" id="end-date-export"/>
      </b-form-group>
      <b-button type="submit" variant="success" block :disabled="isDownloading">
        <b-spinner small v-show="isDownloading"></b-spinner>
        <b-icon-download/>&nbsp;Esporta Adesioni
      </b-button>
    </b-form>
    <br/>
    <b-button @click="downloadRefreshCampaignCsv" variant="info" block :disabled="isDownloading">
      <b-spinner small v-show="isDownloading"></b-spinner>
      <b-icon-download/>&nbsp;Esporta Report Campagna Refresh
    </b-button>
  </b-card-body>
</template>

<script>
import MembershipApi from "../api/MembershipApi"
import DatePicker from "../components/DatePicker"

export default {
  name: 'Export',
  components: {DatePicker},
  provide() {
    return {parentValidator: this.$validator}
  },
  data: () => ({
    startDate: null,
    endDate: null,
    isDownloadingStats: false
  }),
  methods: {
    downloadRefreshCampaignCsv() {
      const startDate = '2024-04-02'

      this.isDownloading = true
      MembershipApi.downloadRefreshCampaignCsv(startDate)
        .then(() => MembershipApi.downloadCountRefreshCampaignCsv(startDate))
        .finally(() => {
          this.isDownloading = false
        })
    },
    downloadCsv(event) {
      if (event) event.preventDefault()
      this.isDownloading = true
      MembershipApi
        .downloadCsv(this.startDate, this.endDate)
        .then(result => {
          console.log(result.data)
          MembershipApi.fileDownload(result.data)
        })
        .finally(() => {
          this.isDownloading = false
        })
    }
  }
}
</script>
